import { configureRequest, replacePathVariables } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { getUserRole } from '../../../../shared/functions/UserRole/userRoleManagment.functions'
import type { FulfillmentOrderDetails, GetFulfillmentOrderDetailsRequest } from './getFulfillmentOrderDetails.types'

export const getFulfillmentOrderDetailsApi = async (
  request: GetFulfillmentOrderDetailsRequest
): Promise<FulfillmentOrderDetails> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.fulfillmentOrders.getFulfillmentOrderDetails, { orderId: request.orderId }),
    method: 'GET',
    headers: {
      'X-User-Role': getUserRole() || ''
    }
  })

  return (response as { data: FulfillmentOrderDetails }).data
}
